import React, { FC } from 'react'

import { ErrorHandler, Loader } from 'components'

import { usePrivacyPolicyLink } from '../hooks/usePrivacyPolicyLink'
import { PrivacyPolicyLinkView } from './PrivacyPolicyLinkView'
import { TPrivacyPolicyLinkProps } from '../types/privacyPolicyLink.types'

export const PrivacyPolicyLink: FC<TPrivacyPolicyLinkProps> = ({
  customTitle,
  customDetails,
  customButtonText,
}) => {
  const { content, traceDetails, componentName, isLoading, isError } = usePrivacyPolicyLink()

  if (isLoading) return <Loader />

  if (isError) return <ErrorHandler traceDetails={traceDetails} componentName={componentName} />

  const { title, details, confirmButton } = content

  return (
    <PrivacyPolicyLinkView
      title={customTitle ?? title}
      details={customDetails ?? details}
      confirmButton={customButtonText ?? confirmButton}
    />
  )
}
